import ProductList from "./ProductList";
import ProductCreate from "./ProductCreate";
import ProductEdit from "./ProductEdit";
import ProductShow from "./ProductShow";
import ProductIcon from "@mui/icons-material/Fastfood";

const products = {
  list: ProductList,
  create: ProductCreate,
  edit: ProductEdit,
  show: ProductShow,
  icon: ProductIcon,
};

export default products;
